import { useCallback } from 'react';
import type { GroupScope } from '../models';

export const useGetGroupScopeName = () =>
  useCallback(({ entityScope }: { entityScope: GroupScope }) => {
    switch (entityScope) {
      case 'associations':
        return 'Associations';
      case 'denominations':
        return 'Denominations';
      case 'districts':
        return 'Districts';
      case 'jurisdictions':
        return 'Jurisdictions';
      case 'organizations':
        return 'Churches';
      case 'privateLabelApps':
        return 'Private Label Apps';
      case 'regions':
        return 'Regions';
      case 'state-conventions':
        return 'State conventions';
    }
  }, []);
